import React from "react";
import { Route, Switch } from "react-router-dom";
import LoginPage from "./app/LoginPage";
import LogoutPage from "./app/LogoutPage";
import ForgotPasswordPage from "./app/ForgotPasswordPage";
import FlashMessageStore from "../../stores/FlashMessageStore";
import NotFoundPage from "~/components/NotFoundPage";

const flashMessageStore = new FlashMessageStore();

export default (
  <Switch>
    <Route
      path={[
        "/",
        "/promptLogin",
        "/promptLogin//:promptEvenIfLoggedIn(\\d+)?",
        "/promptLogin/:continueUrl?/:promptEvenIfLoggedIn(\\d+)?",
      ]}
      exact
      render={props => <LoginPage {...props} flashMessageStore={flashMessageStore} />}
    />
    <Route path="/doLogout" exact render={props => <LogoutPage {...props} flashMessageStore={flashMessageStore} />} />
    <Route
      path="/doForgotPassword"
      exact
      render={props => <ForgotPasswordPage {...props} flashMessageStore={flashMessageStore} />}
    />
    <Route
      path="*"
      render={() => (
        <NotFoundPage
          helpText="Sorry, the page you were looking for could not be found."
          continueLinkUrl="/"
          continueLinkText="Login"
        />
      )}
    />
  </Switch>
);
